import Api from '../../api/Api'

const dashboard = {
  //set namespace true
  namespaced: true,

  //state
  state: {
    webinar_terdekat: [],
    workshop_terdekat: [],
    transaksi: [],
    empty: '',
  },

  //mutations
  mutations: {
    SET_EMPTY(state, data) {
      state.empty = data
    },
    SET_WEBINAR_TERDEKAT(state, data) {
      state.webinar_terdekat = data
    },
    SET_WORKSHOP_TERDEKAT(state, data) {
      state.workshop_terdekat = data
    },
    SET_TRANSACTION(state, data) {
      let transaksi = []
      data.forEach((el) => {
        let a = {
          id_transaksi: el.id_transaksi,
          id_user: el.id_transaksi,
          name: el.nama_pelanggan,
          email: el.email_pelanggan,
          judul: el.judul,
          batch: el.batch,
          phone: el.telepone_pelanggan,
          status: el.id_status_transaksi,
          keterangan: el.keterangan,
          purpose: el.jenis_pembelian,
          date: el.created_at,
          link_pembayaran:
            'https://app.midtrans.com/snap/v2/vtweb/' + el.snap_token,
          coupon: el.kode_kupon,
          method: el.bank_transfer,
          fee_channel: el.fee_channel,
          income: el.net_admin,
          agen: el.nama_agen,
          email_agen: el.email_agen,
          avatar: el.avatar,
          invoice: el.invoice ? el.invoice : '-',
          referral_by: el.referral_by,
          snap: el.snap_token,
          fee_reseller: el.net_komisi,
        }
        transaksi.push(a)
      })

      state.transaksi = transaksi
    },
    SET_EMPTY(state, empty) {
      state.empty = empty
    },
  },

  //actions
  actions: {
    index() {
      return new Promise((resolve, reject) => {
        Api.get(`/dashboard`)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    transaksi({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.get(
          `/dashboard/semuaTransaksi?search=${data.search}&start=${data.start}&end=${data.end}&status=${data.status}&page=${data.page}&per_page=${data.per_page}`,
        )
          .then((response) => {
            commit('SET_TRANSACTION', response.data.data.data)
            resolve(response.data.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    summary({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.get(
          `/dashboard/dashboardAdmin?info=${data.info}&pekerjaan=${data.pekerjaan}&instansi=${data.instansi}&kota=${data.kota}`,
        )
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    akan_datang({ commit }) {
      return new Promise((resolve, reject) => {
        Api.get(`/dashboard/webinar_terdekat`)
          .then((response) => {
            commit('SET_WEBINAR_TERDEKAT', response.data.data.data)
            commit('SET_WORKSHOP_TERDEKAT', response.data.data_workshop.data)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    webinar_disukai() {
      return new Promise((resolve, reject) => {
        Api.get(`/webinar_disukai`)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    workshop_disukai() {
      return new Promise((resolve, reject) => {
        Api.get(`/workshop_disukai`)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
  },

  //getters
  getters: {
    getWebinarTerdekat(state) {
      return state.webinar_terdekat
    },
    getWorkshopTerdekat(state) {
      return state.workshop_terdekat
    },
    getTransaksi(state) {
      return state.transaksi
    },
  },
}

export default dashboard
